import { ActionTree } from 'vuex'
import * as types from './types'
import api from '../api'

export default <ActionTree<recipient.state.RecipientState, RootState>>{
	async [types.RECIPIENT_INIT](action) {
		const user = action.rootState.$account?.current?.user;        
		
        if(action.state.currentCompany == null) {
            action.commit(types.RECIPIENT_COMPANY_CHANGE, user?.comCode ?? null);
        }

        const companyCode = action.state.currentCompany
			
		// 부서 트리 구조 로드
		await action.dispatch(types.RECIPIENT_DEPT_LIST, {
			parentDeptCode: null,
			comCode: companyCode,
			level: 20, // 트리 구조를 한번에 로드
		})

		try {            
            if(user?.comCode === companyCode) {
                // 로그인한 사용자 소속 부서까지 확장
                var department = await action.dispatch(types.RECIPIENT_DEPT_PATH, {
                    comCode: user?.comCode,
                    deptCode: user?.deptCode,
                })

                // 로그인한 사용자 소속 부서의 구성원 로드
                if (department) {
                    await action.dispatch(types.RECIPIENT_USER_LIST, {
                        deptCode: department.deptCode,
                        comCode: department.comCode,
                        parentDeptCode: department.parentDeptCode,
                    })

                    // [Custom][2024-09-04][김지훈] 내 위치로 스크롤
                    var trigger = setInterval(() => {
                        var elemISME = (document as any).querySelector('.isme');
                        if (elemISME) {
                            clearInterval(trigger);
                            var topScroll = Number(elemISME.offsetTop);
                            var pos = window.innerHeight - topScroll;
                            window.scrollTo(window.scrollX, pos)
                        }
                    }, 11)

                    setTimeout(() => {
                        clearInterval(trigger);
                    }, 10000);
                    
                }
                return department
            } else {
                return null;
            }			
		} catch (e) {
			console.error(e)
		}
	},

	
	[types.RECIPIENT_USER_SELECT](action, user: recipient.OrgPerson) {
		action.commit(types.RECIPIENT_USER_SELECT, user)
	},

	[types.RECIPIENT_USER_UNSELECT](action, user: recipient.OrgPerson) {
		action.commit(types.RECIPIENT_USER_UNSELECT, user)
	},

	[types.RECIPIENT_USER_SELECTALL](action, user: recipient.OrgPerson) {
		action.commit(types.RECIPIENT_USER_SELECTALL, user)
	},

	[types.RECIPIENT_COMPPANIES_LIST](action, payload: boolean = false)  {
	
		api.hr.getCompanies(payload).then(res=>{
			action.commit(types.RECIPIENT_COMPPANIES_LIST, res)	
		})
	},


	[types.RECIPIENT_DEPT_LIST](
		action,
		payload: recipient.DepartmentOption
	): Promise<recipient.Department[]> {
		return api.hr
			.getOrgTree(payload)		
			.then((items) => {
				const data = {
					parentDeptCode: payload.parentDeptCode,
					children: items,
				}
				action.commit(types.RECIPIENT_DEPT_LIST, data)
				return items
			})
	},

	async [types.RECIPIENT_DEPT_PATH](
		action,
		payload: recipient.DepartmentOption
	): Promise<recipient.Department | null> {
		const targetDeptCode = payload.deptCode
		const path = await api.hr.getDeptPath(payload.comCode, targetDeptCode)
		const treeItems = action.state.orgchart.dept.items

		let currentDepartment: recipient.Department | undefined
		/**
		 * 부서 코드를 이용하여 확장할 부서 인스턴스를 찾습니다.
		 * @param deptCode 조회할 부서코드
		 * @returns 부서 객체
		 */
		const getDepartmnet = (deptCode: string) => {
			return (currentDepartment?.children || treeItems || [])
				.filter((dept) => dept.deptCode === deptCode)
				.pop()
		}

		/**
		 * 사용자가 속한 소속 부서까지 확장하고 부서 인스턴스를 얻습니다.
		 * @param departments 부서 목록
		 * @returns 사용자 소속 부서
		 */
		const expand = (departments: string[]): recipient.Department | null => {
			const deptCode = departments.pop()
			if (!deptCode || !(currentDepartment = getDepartmnet(deptCode))) {
				throw new Error(
					'INVALID_OPERATION_ERROR: There are no more department paths available.'
				)
			}

			// 부서 확장
			currentDepartment.expanded = true

			// 소속 부서 확인
			if (currentDepartment.deptCode === targetDeptCode) {
				return currentDepartment // 로그인 사용자의 소속 부서
			}

			// 하위 부서 확장
			if (currentDepartment.children && currentDepartment.children.length > 0) {
				if (currentDepartment) {
					action.dispatch(types.RECIPIENT_USER_LIST, {
						deptCode: currentDepartment.deptCode,
						comCode: currentDepartment.comCode,
						parentDeptCode: currentDepartment.parentDeptCode,
					})
				}
				return expand(departments) // 하위 부서 확장
			} else {
				// 부서 검색 실패
				throw new Error(
					`NOT_FOUND_ERROR: Department ${currentDepartment.deptName}(${currentDepartment.deptCode})` +
					'no longer contains subdivisions.'
				)
			}
		}

		let departments: string[] = (path || '')
			.split('/')
			.slice(1)
			.reverse()
      
		return expand(departments)
	},

	[types.RECIPIENT_USER_LIST](action, payload: recipient.DepartmentOption) {
		var dept = payload || action.state.orgchart.dept.current
		if (dept) {
			const data = {
				deptCode: dept.deptCode,
				comCode: dept.comCode,
				parentDeptCode: dept.parentDeptCode,
			}
			return api.hr.getEmployeeList(data).then((res) => {
				const payload = {
					...data,
					list: res.items,
				}
				const statusPayload = {
					personCodes: res.items.map((x: any) => x.personCode),
					deptCode: dept.deptCode,
				}
				action.commit(types.RECIPIENT_USER_LIST, payload) // 현재 해당 부서의 users에다가 부서원 넣어주는거
			})
		}
	},

	[types.RECIPIENT_SEARCH](action, keyword: string) {
		const comCode = action.state.currentCompany as string

		// 검색 전 이전 결과 초기화
		action.commit(types.RECIPIENT_SEARCH, null)

		// 신규 검색 시작
		return api.hr
			.searchOrg(keyword, comCode)
			.then((res: recipient.PagedItemList<recipient.OrgPerson>) => {
				action.commit(types.RECIPIENT_SEARCH_KEYWORD, keyword)
				action.commit(types.RECIPIENT_VIEW_MODE, 'search')
				action.commit(types.RECIPIENT_SEARCH, res)
				return res
			})
	},

	[types.RECIPIENT_SEARCH_CANCEL](action) {
		// 검색 전 이전 결과 초기화
		action.commit(types.RECIPIENT_SEARCH, null)
		action.commit(types.RECIPIENT_VIEW_MODE, 'tree')
		action.commit(types.RECIPIENT_SEARCH_KEYWORD, null)
	},
}
